var colors = {
  line: "#514248",
  unfinished : "#dbb4ad",
  ray: "#ebb4a2",
  secondary: "#efe2d4",
  red: "#a02e61",
  lightRed: "hsla(337, 20%, 40%, 0.5)",
  light: "#ffe3dc",
  slight: "#99ad7c",
  circle: "#53ab6d",
};


export default colors
